import { Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { PayoutRequestStatus, PayoutRequestUIModel } from '../payout-request/payout-request.model';
import { PaymentStatusBadgeComponent } from './payment-status-badge.component';

@Component({
  selector: 'dojo-payment-request-status-cell-renderer',
  template: `
    @if (status) {
      <div [matTooltip]="statusReason" class="cursor-help">
        <dojo-payment-status-badge [status]="status" [config]="{ size: 'sm', showIcon: true }" />
      </div>
    }
  `,
  imports: [MatTooltip, PaymentStatusBadgeComponent],
})
export class PaymentRequestStatusCellRendererComponent extends BaseCellRendererComponent<
  PayoutRequestStatus | null,
  PayoutRequestUIModel
> {
  get status(): PayoutRequestStatus | null {
    return this.params?.data?.status ?? null;
  }

  get statusReason(): string {
    return this.params?.data?.status_reason ?? '';
  }
}
